<template>
  <button class="btn-submit">{{ label }}</button>
</template>

<script>
export default {
  name: 'ButtonSubmit',
  props: {
    label: String,
  },
}
</script>

<style scoped>
button {
  border: 1px;
  box-shadow: 2px 4px #ccc;
  height: 35px;
  border-radius: 20px;
}
</style>
